import React from "react";
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonContent,
  IonButton,
  IonButtons,
  IonMenuButton,
} from "@ionic/react";
import { useHistory } from "react-router-dom";

const GeneralLedgerView: React.FC = () => {
  const history = useHistory();

  return (
    <IonPage className="pushDown">
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonMenuButton />
          </IonButtons>
          <IonTitle>General Ledger</IonTitle>
          <IonButtons slot="end">
            <IonButton
              onClick={() =>
                history.push("/core-accounting/general-ledger/manual-entry")
              }
            >
              Manual Entry
            </IonButton>
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent>{/* TODO: Add general ledger entries list */}</IonContent>
    </IonPage>
  );
};

export default GeneralLedgerView;
